@if(wizardStore.J().form; as formGroup){
<form [formGroup]="formGroup">
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'companyExtracts'"
      [formControls]="formGroup.controls.companyExtracts"
      [canAdd]="false"
      [showIsPublicCheckbox]="true"
    />
    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'technicalUpload'"
      [formControls]="formGroup.controls.technicalUpload"
      [canAdd]="false"
      [showIsPublicCheckbox]="true"
    />
    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'valuation'"
      [formControls]="formGroup.controls.valuation"
      [canAdd]="false"
      [showIsPublicCheckbox]="true"
    />
    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'otherDocs'"
      [formControls]="formGroup.controls.otherDocs"
      [canAdd]="true"
      [showIsPublicCheckbox]="true"
      (createNewFileGroup)="createNewOtherDocs()"
      (fileRemoved)="removeOtherDocs($event)"
    />
    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'mainImage'"
      [formControls]="formGroup.controls.mainImage"
      [canAdd]="false"
      [showIsPublicCheckbox]="true"
    />
    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'images'"
      [formControls]="formGroup.controls.images"
      [canAdd]="true"
      [showIsPublicCheckbox]="true"
      (createNewFileGroup)="createNewImages()"
      (fileRemoved)="removeImages($event)"
    />
    <app-upload-files
      class="file-upload"
      [title]="translationKey + 'videos'"
      [formControls]="formGroup.controls.videos"
      [canAdd]="true"
      [showIsPublicCheckbox]="true"
      (createNewFileGroup)="createNewVideos()"
      (fileRemoved)="removeVideos($event)"
    />
  </app-card>
</form>

}
